export const languages = [
  { key: "it", countryCode: "IT" },
  { key: "en", countryCode: "GB" },
  // not yet used
  // {key: 'es', countryCode: 'ES'},
  // {key: 'fr', countryCode: 'FR'},
  // {key: 'de', countryCode: 'DE'},
];
